import {createAction} from '@reduxjs/toolkit'
import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {getMemberId} from '../selectors/user'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'

export const GET_MY_TICKETS_OLD = createActions('GET_MY_TICKETS_OLD')

export const getMyTicketsOld = (eventId: string) => (dispatch: Function, getState: GetState) =>
  dispatch(callAPI(GET_MY_TICKETS_OLD, eventId, getMemberId(getState())))

export const getMyTickets = createAsyncAction<{tickets: wix.events.ticketing.Ticket[]}, {eventId: string}>(
  'GET_MY_TICKETS',
  async ({eventId}, {getState, extra: {serverApi}}) => serverApi.getMyTickets(eventId, getMemberId(getState())),
)

export const downloadTicketsAction = createAction<string>('DOWNLOAD_TICKETS_ACTION')
